import { fireGTMEvent } from "@/functions/fireGTMEvent";
import { addAlert, showModal } from "@/redux/message/messageSlice";
import {
  SetVote,
  downvote,
  hideSbcSet,
  markSbcSetAsFavorite,
  markSbcSetSolved,
  upvote,
} from "@/redux/sbcs/sbcSetsSlice";
import { updateSbcsSolved } from "@/redux/sbcs/sbcsSlice";
import { AppDispatch } from "@/redux/store";

export function handleFavoriteToggle(dispatch: AppDispatch, sbcSet: any) {
  const isFavorite = sbcSet?.isFavorite;
  const setName = sbcSet?.name;

  dispatch(
    markSbcSetAsFavorite({ setId: sbcSet?.id, isFavorite: !isFavorite }),
  );

  dispatch(
    addAlert({
      description: `${isFavorite ? "Removed" : "Marked"} ${setName} as favorite`,
      type: "success",
    }),
  );

  fireGTMEvent("clicked_favorite");
}

export function handleHideToggle(dispatch: AppDispatch, sbcSet: any) {
  const isHidden = sbcSet?.isHidden;

  dispatch(hideSbcSet({ setId: sbcSet?.id, isHidden: !isHidden }));

  dispatch(
    addAlert({
      description: `${isHidden ? "Removed" : "Marked"} ${sbcSet?.name} as hidden`,
      type: "success",
    }),
  );

  fireGTMEvent("clicked_hide");
}

export function handleCompleteToggle(dispatch: AppDispatch, sbcSet: any) {
  const isCompleted = sbcSet?.solvedCount === sbcSet?.sbcsCount;

  dispatch(markSbcSetSolved({ setId: sbcSet?.id, didComplete: !isCompleted }));
  dispatch(updateSbcsSolved({ setId: sbcSet?.id, solved: !isCompleted }));

  dispatch(
    addAlert({
      title: "Completed SBC",
      description: `${isCompleted ? "Removed" : "Completed"} ${sbcSet?.name}`,
      type: "success",
    }),
  );
}

export function handleVote(
  dispatch: AppDispatch,
  sbcSet: any,
  vote: SetVote,
  userUuid: string | null,
) {
  const setId = sbcSet?.id;

  if (userUuid) {
    fireGTMEvent("clicked_vote");

    dispatch(vote === "UPVOTE" ? upvote({ setId }) : downvote({ setId }));

    if (vote === "UPVOTE" && !sbcSet?.wasUpvoted) {
      dispatch(
        addAlert({
          description: `Upvoted ${sbcSet?.name}`,
          type: "success",
        }),
      );
    } else if (vote === "DOWNVOTE" && !sbcSet?.wasDownvoted) {
      dispatch(
        addAlert({
          description: `Downvoted ${sbcSet?.name}`,
          type: "success",
        }),
      );
    }
  } else {
    dispatch(
      showModal({
        modalType: "login-required",
        freeFeatureLoggedInRequiredHook: "upvote/downvote-sbc",
      }),
    );
  }
}
